<template>
  <div>
    <div
      v-if="loading"
      class="mt-3 overview_items-wrapper"
    >
      <div
        v-for="item in Array.from({ length: 15 }, (_, i) => i + 1)"
        :key="item"
        class="shimmer-box"
      ></div>
    </div>
    <div v-else class="mt-3 overview_items-wrapper">
      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Uptime
        </div>
        <div
          class="py-3"
          style="
            background: linear-gradient(
              to left top,
              rgb(79 79 79) 0%,
              rgb(42 51 78) 67%
            );
          "
        >
          <h4 style="color: white">
            <b>{{
              pppActiveSessions?.length > 0
                ? pppActiveSessions[0].Uptime?.substring(0, 20)
                : "N/A"
            }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          PPPOE ID
        </div>
        <div
          class="py-3"
          style="
            background: linear-gradient(
              to left top,
              rgb(125 92 92) 0%,
              rgb(98 112 153) 67%
            );
          "
        >
          <h4 style="color: white">
            <b>{{ singleUserDbData.nowdb?.PPPOE_ID ?? "N/A" }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          dBm
        </div>
        <div
          class="py-3"
          style="
            background: linear-gradient(
              to right,
              rgb(8 138 165) 0%,
              rgb(8 101 93) 99%
            );
          "
        >
          <h4 style="color: white">
            <b>{{ description?.substring(0, 20) ?? "N/A" }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Upload / Download
        </div>
        <div
          class="py-3"
          style="
            background: linear-gradient(
              to left top,
              rgb(211 32 32) 0%,
              rgb(169 52 81) 67%
            );
          "
        >
          <h4 style="color: white">
            <b>{{ totalRx ?? "N/A" }} / {{ totalTx ?? "N/A" }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Olt Name
        </div>
        <div
          class="py-3"
          style="
            background: linear-gradient(
              to left top,
              rgb(209 95 34) 0%,
              rgb(179 120 70) 67%
            );
          "
        >
          <h4 style="color: white">
            <b>{{ oltConnectOltName?.substring(0, 20) || "N/A" }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Vendor
        </div>
        <div
          class="py-3"
          style="
            background: linear-gradient(
              to left top,
              rgb(107 24 131) 0%,
              rgb(165 25 151) 67%
            );
          "
        >
          <h4 style="color: white">
            <b>{{ vendor?.substring(0, 20) || "N/A" }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Router Brand
        </div>
        <div class="py-3">
          <h4>
            <b>{{
              pppActiveSessions?.length > 0
                ? pppActiveSessions[0]?.Company?.substring(0, 20)
                : "N/A"
            }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Remote Address
        </div>
        <div class="py-3">
          <h4>
            <b>{{
              pppActiveSessions?.length > 0
                ? pppActiveSessions[0]?.RemoteAddress?.substring(0, 20)
                : "N/A"
            }}</b>
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Temperature / Vlan ID
        </div>
        <div class="py-3">
          <h4>
            <b
              >{{ temperatureOnu?.substring(0, 20) ?? "N/A" }} °C /
              {{
                singleUserDbData.nowdb?.vlan_id?.substring(0, 20) ?? "N/A"
              }}</b
            >
          </h4>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Last Update
        </div>
        <div class="py-3">
          <h5>
            <b>{{ lastUpdate ?? "N/A" }}</b>
          </h5>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Last Disconnect / Time
        </div>
        <div class="py-3">
          <span
            v-if="refreshLoader"
            class="spinner-border spinner-border-sm mx-3"
          ></span>
          <span v-else>
            <h4>
              <b
                >{{ lastDeregReason?.substring(0, 10) ?? "N/A" }} /
                {{ aliveTime ? aliveTime : "N/A" }}</b
              >
            </h4>
          </span>
        </div>
      </div>

      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Port Number
        </div>
        <div class="py-3">
          <h4>
            <b>{{ portNumber?.substring(0, 20) ?? "N/A" }}</b>
          </h4>
        </div>
      </div>
      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Down Count
        </div>
        <div class="py-3 cursor-pointer" @click="$emit('fetch-history-data', singleUserDbData.nowdb?.PPPOE_ID)">
          <h4>
            <b>{{ downCount ?? "N/A" }}</b>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverviewCards",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    pppActiveSessions: {
      type: Array,
      default: () => [],
    },
    singleUserDbData: {
      type: Object,
      default: () => ({}),
    },
    description: {
      type: String,
      default: null,
    },
    totalRx: {
      type: String,
      default: null,
    },
    totalTx: {
      type: String,
      default: null,
    },
    oltConnectOltName: {
      type: String,
      default: "",
    },
    vendor: {
      type: String,
      default: null,
    },
    temperatureOnu: {
      type: String,
      default: "",
    },
    lastUpdate: {
      type: String,
      default: null,
    },
    lastDeregReason: {
      type: String,
      default: null,
    },
    aliveTime: {
      type: String,
      default: null,
    },
    portNumber: {
      type: String,
      default: null,
    },
    downCount: {
      type: String,
      default: "",
    },
    refreshLoader: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['fetch-history-data'],
};
</script>

<style scoped>
.shimmer-box {
  width: 100%;
  height: 100px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 3.5s infinite linear;
  border-radius: 4px;
  margin-bottom: 10px;
}

.dark-mode .shimmer-box {
  background: linear-gradient(90deg, #586b836e 25%, #213550 50%, #34476736 75%);
  background-size: 200% 100%;
  animation: shimmer 3.5s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>

